export enum TicketStatus {
  UNKNOWN = ' ',
  PENDING = 'PENDING',
  PAID = 'PAID',
  ERROR = 'ERROR',
  SUBSCRIBED = 'SUBSCRIBED',
  SUBSCRIPTION_CANCELED = 'SUBSCRIPTION_CANCELED',
  PENDING_ACTIVATION = 'PENDING_ACTIVATION',
}

export enum PaymentLinkStatus {
  UNKNOWN = 'UNKNOWN',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  DELETED = 'DELETED',
  ERROR = 'ERROR',
  SUBSCRIBED = 'SUBSCRIBED',
  SUBSCRIPTION_CANCELED = 'SUBSCRIPTION_CANCELED',
  PENDING_ACTIVATION = 'PENDING_ACTIVATION',
  EXPIRED = 'EXPIRED',
}

export const PAYMENT_LINK_STATUS_NOT_ALLOWED_TO_SHOW = [
  PaymentLinkStatus.DELETED,
  PaymentLinkStatus.ERROR,
];

export enum PaymentLinkType {
  SINGLE_PAYMENT = 'SINGLE_PAYMENT',
  MULTI_PAYMENT = 'MULTI_PAYMENT',
  SUBSCRIPTION = 'SUBSCRIPTION',
}

export enum PaymentLinkRedirectParams {
  STATUS = 's',
  REDIRECT_URL = 'redirect_uri',
  AUTO_REDIRECT = 'redirect_auto',
}
export enum PaymentLinkRedirectStatus {
  SUCCESS = '1',
  ERROR = '0',
}

export enum Partner {
  UNKNOWN = 'UNKNOWN',
  KUSHKI = 'KUSHKI',
  DLOCAL = 'DLOCAL',
  OYSTER = 'OYSTER',
  OPENPAY = 'OPENPAY',
  STP = 'STP',
  ARCUS = 'ARCUS',
  FISERV = 'FISERV',
  BLUMON = 'BLUMON',
  REDPAY = 'REDPAY',
  BELVO = 'BELVO',
  STRIPE = 'STRIPE',
  FINTOC = 'FINTOC',
  MONATO = 'MONATO',
}

export enum BusinessType {
  PERSONA_FISICA = 'PERSONA_FISICA',
  PERSONA_MORAL = 'PERSONA_MORAL',
}

export enum RedirectAutoOptions {
  ENABLED = '1',
  DISABLED = '0',
}

export enum PAYMENT_LINK_PAYMENT_METHODS {
  CARD_SUBSCRIPTION = 'CARD_SUBSCRIPTION',
  CARD = 'CARD',
  SPEI = 'SPEI',
  CASH = 'CASH',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
}

export const ONLY_CARD_FORM = [
  PAYMENT_LINK_PAYMENT_METHODS.CARD_SUBSCRIPTION,
  PAYMENT_LINK_PAYMENT_METHODS.CARD,
];

export default {
  [`${PaymentLinkStatus.UNKNOWN}`]: TicketStatus.UNKNOWN,
  [`${PaymentLinkStatus.ACTIVE}`]: TicketStatus.PENDING,
  [`${PaymentLinkStatus.CLOSED}`]: TicketStatus.PAID,
  [`${PaymentLinkStatus.DELETED}`]: TicketStatus.ERROR,
  [`${PaymentLinkStatus.ERROR}`]: TicketStatus.ERROR,
  [`${PaymentLinkStatus.SUBSCRIBED}`]: TicketStatus.SUBSCRIBED,
  [`${PaymentLinkStatus.SUBSCRIPTION_CANCELED}`]: TicketStatus.SUBSCRIPTION_CANCELED,
  [`${PaymentLinkStatus.PENDING_ACTIVATION}`]: TicketStatus.PENDING_ACTIVATION,
};

export const MAX_ALLOWED_CARD_PAYMENT = 100000;
export const MAX_ALLOWED_CASH_PAYMENT = 20000;

export const BELVO_SUPPORTED_BANKS_BY_CODE = {
  '002': 'CITIBANAMEX',
  '012': 'BBVA BANCOMER',
  '014': 'SANTANDER',
  '019': 'BANJERCITO',
  '021': 'HSBC',
  '030': 'BAJIO',
  '036': 'INBURSA',
  '042': 'MIFEL',
  '044': 'SCOTIABANK',
  '058': 'MONTERREY_REGIONAL',
  '059': 'INVEX',
  '062': 'AFIRME',
  '072': 'BANORTE',
  '106': 'AMERICA',
  '113': 'VE POR MAS',
  '127': 'AZTECA',
  '130': 'COMPARTAMOS',
  '132': 'MULTIVA',
  '133': 'PRUDENTIAL',
  '136': 'INTERBANCO',
  '137': 'BANCOPPEL',
  '143': 'CI',
  '151': 'FUNDACION DONDE',
  '152': 'BANCREA',
  '147': 'BANKAAOL',
};

export const BELVO_SUPPORTED_BANKS_CODES = [
  '002',
  '012',
  '014',
  '019',
  '021',
  '030',
  '036',
  '042',
  '044',
  '058',
  '059',
  '062',
  '072',
  '106',
  '113',
  '127',
  '130',
  '132',
  '133',
  '136',
  '137',
  '143',
  '151',
  '152',
  '147',
];
